import { render, staticRenderFns } from "./NewSupplier.vue?vue&type=template&id=6087f8e8"
import script from "./NewSupplier.vue?vue&type=script&lang=js"
export * from "./NewSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports